$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});
$(document).ready(function(event){
    $('.slider-immagini').slick({
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      respondTo: 'min',
      verticalScrolling: false,
      infinite: true,
      dots: true,
      responsive: [
      {
        breakpoint: 940,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
      ]

  });

  $('.slider-immagini').slickLightbox({
      src: 'src',
      itemSelector: '.slick-slide img',
      // imageMaxHeight: 1
  });

  if ($('#mostra-commenti').length) {
      $('#mostra-commenti').slick( {
      centerMode: true,
      centerPadding: '200px',
      slidesToShow: 1,
      // slidesToScroll: 1,
      // respondTo: 'min',
      verticalScrolling: false,
      infinite: true,
      responsive: [
      {
        breakpoint: 2000000000,
        settings: {
          slidesToShow: 1,
          // slidesToScroll: 1
        }
      },
      {
        breakpoint: 940,
        settings: {
          slidesToShow: 1,
          // slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '40px',
          // slidesToScroll: 2,
        }
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
      ]

      });
  }

  $('#lista-immobili').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      respondTo: 'min',
      verticalScrolling: false,
      autoplay: true,
      dots: true, 
      arrows: false,
      responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 940,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
      ]

  });

  var sideslider = $('[data-toggle=collapse-side]');
      var sel = sideslider.attr('data-target');
      var sel2 = sideslider.attr('data-target-2');
      sideslider.click(function(event){
          $(sel).toggleClass('in');
          $(sel2).toggleClass('out');
      });

      $('#nav-icon4').click(function(){
          $(this).toggleClass('open');
      });
      $(document).ready(function(){
        $(".hamburger").click(function(){
          $(this).toggleClass("is-active");
        });
      });

  $('#importoimmobile').keyup(function (event) {
      var value = $(this).val();
      value = value.replace(/\./g, "");
      value = parseInt(value);
      value = value ? number_format(value, 0, ",", ".") : '';
      $(this).val(value);
  });

  $('#costo').keyup(function (event) {
      var value = $(this).val();
      value = value.replace(/\./g, "");
      value = parseInt(value);
      value = value ? number_format(value, 0, ",", ".") : '';
      $(this).val(value);
  });

  $('#reddito_mensile').keyup(function (event) {
      var value = $(this).val();
      value = value.replace(/\./g, "");
      value = parseInt(value);
      value = value ? number_format(value, 0, ",", ".") : '';
      $(this).val(value);
  });


  $('#anticipo').keyup(function (event) {
      var value = $(this).val();
      value = value.replace(/\./g, "");
      value = parseInt(value);
      value = value ? number_format(value, 0, ",", ".") : '';
      $(this).val(value);
  });

  $('#importomutuo').keyup(function(event) {
      var value = $(this).val();
      value = value.replace(/\./g, "");
      value = parseInt(value);
      value = value ? number_format(value, 0, ",", ".") : '';
      $(this).val(value);
  });

  $('#anni_rimanenti').keyup(function(event) {
      var value = $(this).val();
      value = value.replace(/\./g, "");
      value = parseInt(value);
      value = value ? number_format(value, 0, ",", ".") : '';
      $(this).val(value);
  });

  $('#costo_mensile').keyup(function(event) {
      var value = $(this).val();
      value = value.replace(/\./g, "");
      value = parseInt(value);
      value = value ? number_format(value, 0, ",", ".") : '';
      $(this).val(value);
  });

  $('#residuo').keyup(function(event) {
      var value = $(this).val();
      value = value.replace(/\./g, "");
      value = parseInt(value);
      value = value ? number_format(value, 0, ",", ".") : '';
      $(this).val(value);
  });
  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })
});

$('li#page_' + $('body').attr('page-id')).addClass('active');